import styled from 'styled-components';

export const StyledPostInfo = styled.div`
  display: flex;
  gap: 15.5px;

  .item-info-section-divider {
    width: 1px;
    background-color: ${({ theme }) => theme.palette.stroke[0]};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 11.5px;

    .item-info-section-divider {
      width: 100%;
      height: 1px;
    }
  }
`;
